/**
 * Related Recipes for in the sidebar
 */

// Import statements
import * as React from "react"

/**
 * Define the RelatedRecipesLinks constant
 * @param title
 * @returns {JSX.Element}
 * @constructor
 */
const RelatedRecipesLinks = ({title}) => {

    return (
        <div className="d-none d-none-md" id="related_recipes_links">
            <h4 className="hidden">{title}</h4>
        </div>
    )
}

/**
 * Export the RelatedRecipesLinks constant
 */
export default RelatedRecipesLinks
